import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import AutoLogin from "./components/auth/AutoLogin";
import { RouterProvider } from "react-router-dom";
import router from "./router";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <AutoLogin>
            <RouterProvider router={router} />
        </AutoLogin>
    </Provider>
);
